import React, { ComponentProps } from 'react'
import DOMPurify from 'dompurify'
import { twMerge } from 'tailwind-merge'

/**
 * Component that takes string/React.ReactNode content and if string,
 * sanitizes and renders it to HTML with dangerouslySetInnerHTML
 */
export const RenderHTMLContent = ({
  children,
  unstyled,
  ...props
}: { children: string | React.ReactNode; unstyled?: boolean } & Omit<
  ComponentProps<'div'>,
  'children'
>) =>
  typeof children === 'string' ? (
    <div
      {...props}
      className={twMerge(!unstyled && 'rich-text-editor', props.className)}
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(children),
      }}
    />
  ) : (
    <div {...props}>{children}</div>
  )
